import { SmallMenu } from '../img/icons/SmallMenu';

const NoDiets = () => {
  return (
    <div className="menu-widget-catering-menu__loader">
      <SmallMenu color="#1F2E4D" />
      <span className="menu-widget-catering-menu__loader-text">
        Niestety catering nie udostępnia rozpisanego menu dla tej diety
      </span>
    </div>
  );
};

export default NoDiets;
